import React, { ReactNode } from 'react'
import './json.css';

interface Props {
    value    : object;
    expandTo : number;
}

export class Json extends React.Component<Props> {

    lineFeed(depth : number) : React.JSX.Element
    {
        if (depth > this.props.expandTo) {
            return <span> </span>;
        }
        else {
            let text = "\n";
            for (let i = 0; i < depth; i++) {
                text += "  ";
            }
            return <span>{text}</span>;
        }
    }

    quoteKey(key : string) : React.JSX.Element
    {
        return (
            <span className="keys">
            { "\"" + key + "\""}
            </span>);
    }

    render()
    {
        return (
            <>
                {this.renderJson(this.props.value, 0)}
                {this.lineFeed(0)}
            </>
        );
    }

    renderJson(value : any, depth : number) : ReactNode
    {
        if (value === null) {
            return this.symbol("null");
        }
        else if (Array.isArray(value)) {
            return (
                <>
                    { this.symbol("[") }
                    { this.lineFeed(depth + 1) }
                    { value.map((item, index, array) => {
                        const isLast = index === array.length - 1;
                        return <React.Fragment key={index}>
                                { this.renderJson(item, depth + 1) }
                                { isLast ? this.lineFeed(depth + 0) : <>{ this.symbol(",") }{ this.lineFeed(depth+1) }</> }
                            </React.Fragment>;
                    })}
                    { this.symbol("]") }
                    </>
            );
        }
        else if (typeof value === 'object') {
            return this.renderObject(value, depth);
        }
        else if (typeof value == 'string') {
            return (<span className="values">{ "\"" + value + "\""}</span>);
        }
        else if (typeof value == 'number') {
            return (<span className="number">{ value }</span>);
        }
        else if (typeof value == 'boolean') {
            return (<span className="boolean">{ value ? "true" : "false" }</span>);
        }
        else {
            return <p>{ typeof value} </p>;
        }
    }

    renderObject(obj : any, depth : number) : ReactNode
    {
        const keys         = Object.keys(obj);
        const maxKeyLength = Math.max(...keys.map(key => key.length + 2));

        return (
            <>
                { this.symbol("{") }
                { this.lineFeed(depth + 1) }
                { keys.map((key, index, array) => {
                    const isLast = index === array.length - 1;
                    const keyLength = key.length + 2; // +2 for quotes
                    const padding = ' '.repeat(maxKeyLength - keyLength);
                    return <React.Fragment key={index}>
                        { this.quoteKey(key) }
                        { this.symbol(padding + " : ") }
                        { this.renderJson(obj[key], depth + 1) }
                        { isLast ? this.lineFeed(depth + 0) : <>{ this.symbol(",") }{ this.lineFeed(depth+1) }</> }
                    </React.Fragment>;
                })}
                { this.symbol("}") }
                </>
        );
    }

    symbol(symbol : string) : ReactNode
    {
        return <span className="symbol">{symbol}</span>;
    }
}

